import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import Typography from '@mui/material/Typography';

export const GridRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  width: '670px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));

export const Form = styled('form')(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column'
}));

export const BoxCard = styled(Box)(({ theme }) => ({
  borderRadius: '16px 16px 0px 0px',
  backgroundColor: theme.palette.neutrals.beige1,
  width: '100%',
  padding: `${theme.spacing(5)} ${theme.spacing(3)}`,
  flex: '1'
}));

export const BackButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.neutrals.beige1,
  padding: 0
}));

export const AddressActionButton = styled(LoadingButton)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  '&.Mui-disabled': {
    fontWeight: '400'
  }
}));

export const NoAddressActionButton = styled(LoadingButton)(({ theme }) => ({
  display: 'flex',
  minWidth: '80px',
  backgroundColor: theme.palette.neutrals.beige3,
  justifyContent: 'space-between',
  '&.Mui-disabled': {
    fontWeight: '400'
  }
}));

export const Actions = styled(Box)({
  display: 'flex',
  paddingBottom: '24px',
  paddingRight: '10px'
});

export const AddressTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const AddressRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  position: 'relative',
  backgroundColor: theme.palette.neutrals.beige1,
  borderRadius: '8px',
  minHeight: theme.spacing(10),
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  marginBottom: theme.spacing(3),
  cursor: 'pointer',
  '&.disabled': {
    cursor: 'not-allowed',
    opacity: 0.5
  }
}));

export const AddressIconBox = styled(Box)(({ theme }) => ({
  borderRadius: '50%',
  backgroundColor: theme.palette.neutrals.beige3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '48px',
  width: '48px',
  marginRight: theme.spacing(2),
  position: 'absolute',
  left: theme.spacing(2),
  top: theme.spacing(2)
}));

export const AddressIcon = styled(FmdGoodOutlinedIcon)(({ theme }) => ({
  color: theme.palette.neutrals.lead,
  fontSize: '2rem'
}));

export const AddressContent = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(8)
}));
